import { AbstractModel, JsonObject, JsonProperty, DateConverter } from 'projects/core/src/public-api';
import { TrelloCard } from '../../../trello-misc/data/trello-card';
import { User } from 'projects/core/src/lib/login/data/user';
import { TrelloCheckItem } from '../../../trello-misc/data/trello-check-item';
import { ProjectActivity } from './activity/project-activity';
import { ActivityType } from './activity/activity-type';

@JsonObject('model.file.ProjectFile')
export class ProjectFile extends AbstractModel {

	@JsonProperty(Number, 'id')
	id: number;

	@JsonProperty(String, 'clazz')
	clazz?: string;

	@JsonProperty(String, 'hash')
	hash?: string;

	@JsonProperty(Number, 'activityId')
	activityId?: number;

	@JsonProperty(ActivityType, 'activityType')
	activityType?: ActivityType;

	@JsonProperty(Number, 'checkItemId')
	checkItemId?: number;

	@JsonProperty(String, 'checkItemName')
	checkItemName?: string;

	@JsonProperty(String, 'name')
	name?: string;

	@JsonProperty(String, 'ext')
	ext?: string;

	@JsonProperty(DateConverter, 'uploadTime')
	uploadTime?: Date;

	@JsonProperty(Number, 'size')
	size?: number;

	@JsonProperty(User, 'user')
	user?: User;

}